import React from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { SettingsAPI } from '../lib/api';
import { Card, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Skeleton } from '../components/ui/Skeleton';
import { TopBar } from '../components/TopBar';
import { useToast } from '../components/ui/Toast';
import { Bell } from 'lucide-react';

export function SettingsPage() {
  const { toast } = useToast();

  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: SettingsAPI.get,
  });

  const alertMut = useMutation({
    mutationFn: SettingsAPI.testAlert,
    onSuccess: () => toast('Тестове сповіщення надіслано', 'success'),
    onError: (e: Error) => toast(e.message, 'error'),
  });

  return (
    <div>
      <TopBar title="Налаштування" />
      <div className="p-6 space-y-4 max-w-2xl">
        {isLoading ? (
          <div className="space-y-3">
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-20 w-full" />
          </div>
        ) : (
          <>
            <Card>
              <CardHeader>
                <CardTitle>Дозволені Telegram IDs</CardTitle>
              </CardHeader>
              {settings?.allowedTgIds?.length > 0 ? (
                <ul className="space-y-1">
                  {settings.allowedTgIds.map((id: number | string) => (
                    <li key={id} className="font-mono text-sm text-tg-text">
                      {id}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-tg-text-secondary">Немає обмежень (всі дозволені)</p>
              )}
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Версія</CardTitle>
              </CardHeader>
              <p className="text-sm text-tg-text">
                {settings?.version ?? '—'}
              </p>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Тестове сповіщення</CardTitle>
              </CardHeader>
              <p className="text-sm text-tg-text-secondary mb-3">
                Надіслати тестове повідомлення в Telegram
              </p>
              <Button
                variant="outline"
                loading={alertMut.isPending}
                onClick={() => alertMut.mutate()}
              >
                <Bell size={14} /> Надіслати тест
              </Button>
            </Card>
          </>
        )}
      </div>
    </div>
  );
}
